import { isArrayEmpty } from "@omnia/shared/utils/array"
import { Fragment } from "react"
import { GenericProps } from "../../types"
import { HeaderRow } from "../permissions/HeaderRow"
import { CroppingPermissions } from "./CroppingPermissions"
import { groupings } from "./groupings"
import { GroupPermissions } from "./GroupPermissions"
import { useRestrictedMembers } from "./hooks"
import { UserLevelActivation } from "./UserLevelActivation"


export function Cropping(props: GenericProps) {

    const { state, dispatch, } = props
    const { cropping: { cropping, grouping: groupingKey } } = state

    const grouping = groupings.find(g => g.key === groupingKey)

    const croppingGroups = grouping.grouping(cropping)

    const users = useRestrictedMembers(state.users, state.filters.users)

    const members = users.visible

    if (isArrayEmpty(users.all)) {

        return <div style={{ margin: "3rem 1rem" }}>
            <p>
                There are no users with the 'restricted member' role registered on this holding.
            </p>
        </div>

    }

    return <div className="cropping-permissions">

        <div className="grid-container">

            <div className="grid">

                <HeaderRow users={members} />

                <UserLevelActivation  {...{ ...props, members }} />

                {
                    croppingGroups.map(group => <Fragment key={group.label}>

                        <GroupPermissions {...{ ...props, members, group }} />

                        <>

                            {
                                group.cropping.map(c => <Fragment key={c.croppingId}>

                                    <CroppingPermissions {...{ ...props, members, cropping: c }} />

                                </Fragment>)

                            }


                        </>

                    </Fragment>


                    )
                }


            </div>


        </div>

    </div>

}
